module.exports = __webpack_public_path__ + "img/invoice.0980fede.png";